module.exports = __webpack_public_path__ + "assets/logo-d623f689671f1d8015b085f5cbc70ba2.svg";